/**
 * DataGridUserEvents
 * Registry of events for DataGrid + Pagination components
 */
export enum DataGridUserEvents {
    Sort = "DataGrid - Sort",
    ChangePage = "DataGrid - Change Page",
    Scrollbar = "DataGrid - Scroll with HorizontalScrollbar",
    ClickScrollButton = "DataGrid - Click Scroll to front/back button",
    ClickLoginToUnlock = "DataGrid - Click Login-To-Unlock Header Link",
    ClickUpgradeToUnlock = "DataGrid - Click Upgrade-To-Unlock Header Link",
}
